module.exports = __webpack_public_path__ + "img/checkbox-unselected.d91c9af4.svg";